import { render, staticRenderFns } from "./CloneItemsDialog.vue?vue&type=template&id=390cffa2&"
import script from "./CloneItemsDialog.vue?vue&type=script&lang=js&"
export * from "./CloneItemsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports